module.exports = __webpack_public_path__ + "media/sound.43b478cf.mp3";